module.exports = __webpack_public_path__ + "b10c20f07626c51a7fa6aaf3012e4d9e.png";